/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountDetailsSortCriteria {
    getFixupPrototypeFunction() { return MasterAccountDetailsSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountDetailsSortCriteria>): MasterAccountDetailsSortCriteria {
        let obj = Object.assign(new MasterAccountDetailsSortCriteria(), model);
        MasterAccountDetailsSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountDetailsSortCriteria>): MasterAccountDetailsSortCriteria {
        if (!model) return null;
        return MasterAccountDetailsSortCriteria.newInstance(<MasterAccountDetailsSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountDetailsSortCriteria) {
        if (!obj) return;

        models.MasterAccountDetailsSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountDetailsSortCriteria): boolean {
        Object.setPrototypeOf(obj, MasterAccountDetailsSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.MasterAccountDetailsSortColumn;

    ascending: boolean;

}
